import { CategorySidebar } from '@/modules/layout'
import { HeroSlider } from '../modules/HeroSlider'
import { Benefits } from '../modules/Benefits'
import { PromoCTA } from '../components/PromoCTA'
import { FeaturedProducts } from '../modules/FeaturedProducts'
import { GreenBanner } from '../components/GreenBanner'
import { NewsSection } from '../modules/NewsSection'

export function HomePage() {
  return (
    <div className="max-w-[1440px] mx-auto px-6 py-6 space-y-6">
      <div className="flex gap-6">
        <CategorySidebar />
        <div className="flex-1 min-w-0">
          <HeroSlider />
        </div>
      </div>

      <div className="flex gap-6">
        <div className="flex-1 min-w-0">
          <Benefits />
        </div>
        <PromoCTA />
      </div>

      <div className="flex gap-6">
        <div className="flex-1 min-w-0">
          <FeaturedProducts />
        </div>
        <GreenBanner />
      </div>

      <NewsSection />
    </div>
  )
}
